<template>
  <div class="input-relative">
    <input
      type="text"
      :name="name"
      :placeholder="placeholder"
      v-bind:class="{
        'error-validate': v[name].$invalid && v[name].$dirty
      }"
      :value="v[name].$model"
      class="input-custom"
      :ref="name"
      :readonly="readonly"
      v-on:input="$emit('input', { name: name, value: $event.target.value })"
    />

    <span v-for="(item, index) in validate" :key="index">
      <span
        class="form-error-tip"
        v-if="v[name].$invalid && v[name].$dirty && !v[name][item.type]"
      >
        {{
          $t(item.pathTextLang, {
            split: '/'
          })
        }}
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'VInputRegister',
  props: {
    name: {
      type: String
    },
    v: {
      required: true,
      type: Object
    },
    validate: {
      type: Array
    },
    placeholder: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped></style>
